module.exports = __webpack_public_path__ + "static/media/add-edit-order-item.03c4e8ba.svg";